import axios, { AxiosRequestConfig } from 'axios';
import { GoogleCredentials, MoodleCredentials, RegisterCredentials } from './types';

export const getMoodleServers = async () => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json'
            }
        };

        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/moodle/servers`,
            requestConfig
        );

        return response.data;
    } catch (error) {
        const response = {
            message: 'Erro ao buscar instituições',
            error: error
        };

        console.error(response);

        return response;
    }
};

export const getGoogleUser = async (credentials: GoogleCredentials) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json'
            }
        };

        // csrf-cookie
        await axios.get(`${process.env.REACT_APP_BACKEND_URL}/sanctum/csrf-cookie`);
        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/auth/google`,
            credentials,
            requestConfig
        );

        return response.data.user;
    } catch (error) {
        const response = {
            message: 'Erro de conexão com a API do Google',
            error: error
        };

        console.error(response);

        return response;
    }
};

export const getMoodleUser = async (credentials: MoodleCredentials) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json'
            }
        };

        // csrf-cookie
        await axios.get(`${process.env.REACT_APP_BACKEND_URL}/sanctum/csrf-cookie`);
        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/auth/moodle`,
            credentials,
            requestConfig
        );

        return response.data.user;
    } catch (error) {
        const response = {
            message: 'Erro de conexão com o webService do Moodle',
            error: error
        };

        console.error(response);

        return response;
    }
};

export const register = async (credentials: RegisterCredentials) => {
    try {
        const formData = new FormData();

        formData.append('login_type', credentials.login_type);
        formData.append('image', credentials.image);
        formData.append('name', credentials.name);
        formData.append('surname', credentials.surname);
        formData.append('gender', credentials.gender);
        formData.append('email', credentials.email);
        formData.append('password', credentials.password);
        formData.append('password_confirmation', credentials.password_confirmation);
        formData.append('lgpd_agreed', credentials.lgpd_agreed);

        if (credentials.google_id) {
            formData.append('google_id', credentials.google_id);
        }

        if (credentials.moodle_id) {
            formData.append('moodle_id', credentials.moodle_id);
        }

        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'multipart/form-data',
                Accept: 'application/json'
            }
        };

        // csrf-cookie
        await axios.get(`${process.env.REACT_APP_BACKEND_URL}/sanctum/csrf-cookie`);
        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/auth/register`,
            formData,
            requestConfig
        );

        return response.data.user;
    } catch (error) {
        const response = {
            message: 'Erro ao tentar criar um novo usuário',
            error: error
        };

        console.error(response);

        return response;
    }
};
